export default "__VITE_ASSET__CzLc$yum__"